import { ILoadPublishTermsParams, TLoadPublishTermsResult } from './types';
import { getPublishTermsV2 } from './v2/getPublishTermsV2';
import { getPublishTermsV3 } from './v3/getPublishTermsV3';
import { shouldUsePublishTermsV3 } from './v3/utils';

export async function getPublishTerms(params: ILoadPublishTermsParams): Promise<TLoadPublishTermsResult> {
  const percentage = params.config.get<number>('auction.publishTermsV3.percent') || 0;

  const isV3 = shouldUsePublishTermsV3(params.userId, percentage);

  if (isV3) {
    return getPublishTermsV3(params);
  }

  return getPublishTermsV2(params);
}
